enum ApplicationStatus {
    Closed = 'Closed',
    EligibilityReceived = 'Eligibility Received',
    PartiallyEnrolled = 'Partially Enrolled',
    EnrolledOrActive = 'Enrolled (Or Active)',
    Signed = 'Signed',
}

enum CsrOptionName {
    SPECIAL_ENROLLMENT = 'specialEnroll',
    COVERAGE_DATE = 'coverageDate',
    EDIT = 'edit',
    INITIATE = 'initiate',
    RE_RUN = 'rerun',
    CANCEL_TERM = 'cancelTerm',
    UPDATE = 'update',
    SEND_OUTBOUND_AT = 'sendObAt',
    OVERRIDE_SEP_DENIAL = 'overrideSEPDenial',
    OVERRIDE_APP_EDIT_LOCK = 'overrideApplicationEditLock',
    END_SEP = 'endSep',
}

enum AccountTransferStatus {
    DETERMINED = 'Determined',
    ASSESSED = 'Assessed',
    REFERRAL = 'Referral',
    RECEIVED = 'Received',
}

enum RequestStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

enum ApplicationType {
    QEP = 'QEP',
    SEP = 'SEP',
    OE = 'OE',
    QHP = 'QHP',
    OpenEnrollment = 'Open Enrollment',
}

enum SepDateType {
    MAX = 'MAX',
    MIN = 'MIN',
    
}

enum YesNo {
    Y = 'Y',
    N = 'N',
}

export { ApplicationStatus, CsrOptionName, AccountTransferStatus, RequestStatus, ApplicationType, YesNo, SepDateType };
